import { SearchFormTemplates as BaseTemplates } from '@truelime/react-search';
import FormGroupWrapper from '../formGroupWrapper';
import FormSearchWrapper from '../formSearchWrapper';
import Icon from './Icon';
const Templates = {
    ...BaseTemplates,
    Common: {
        Icon: Icon
    },
    Group: {
        ...BaseTemplates.Group,
        Wrapper: FormGroupWrapper,
        FormSearchWrapper
    }
};
export default Templates;
